module.exports = __webpack_public_path__ + "b120ede04e2683d241bca78d83dfe045.svg";